import $ from "jquery";
import _ from "lodash";

export default function text() {
   const $html = $("html");
   const $scroller = $("html, body");

   $(function(){
      if($('.text + .show .more').length) {

         $.each($('.text.-more'), function(){
            let _this = $(this);
   
            let height = _this.outerHeight();
            _this.attr('data-height', height);
   
            _this.css('height', 300);
         });
   
         $('.show .more').click(_.debounce(function(){
            let _this = $(this);
            let parent = _this.parent();
            let text = parent.prev();
   
            if(text.length) {
               if(text.hasClass('-more')) {
                  text.animate({ height: text.attr('data-height') + 'px' }, { queue:false, duration:300});
                  text.removeClass('-more');
                  _this.text('- Read Less');

                  setTimeout(()=>{
                     text.css('height', 'auto');
                  }, 400);
               } else {
                  text.animate({ height: '300px' }, { queue:false, duration:300});
                  text.addClass('-more');
                  _this.text('+ Read More');
               }
            }
         }, 300));
      }
   });
}



// WEBPACK FOOTER //
// ./source/scripts/sections/text.js